//侧边栏数据
export const slideData  = [
    {
        title:'金融财经',
        value:0
    },
    {
        title:'农业领域',
        value:1
    },
    {
        title:'工业领域',
        value:2
    },
    {
        title:'医疗康养',
        value:3
    },
    {
        title:'文化旅游',
        value:4
    },
    {
        title:'生态环境',
        value:5
    },
    {
        title:'特色数据',
        value:6
    }
]
//折线图配置
export const lineChartOptions =     {
    xAxis: {
        type: 'category',
        boundaryGap: false,
        data:[]
    },
    tooltip: {
        trigger: 'axis'
    },
    // 图例
    legend: {
        data: [],
        x:"center",
        y:"top",
        padding:[30,0,10,0]
    },

    yAxis: {
        type: 'value'
    },
    series: []
}
export const chartMapping = [
    {
        title: ['当月','累计'],
        dateName:['month','sum']
    },
    {
        title: ['制造业','非制造业'],
        dateName:['manufacturingIndex','noManufacturingIndex']
    },
    {
        title: ['全国','城市','农村'],
        dateName:['nationMonth','cityMonth','countrysideMonth'],
        yAxis : { // 纵轴标尺固定
            type : 'value',
            scale : true,
            max : 200,
            min : 0,
            splitNumber : 2,
            boundaryGap : [ 0.1, 0.1 ]
        } ,
    },
    {
        title: ['总指数','农产品','矿产品','煤电油'],
        dateName:['indexValue','agricultureIndex','mineIndexValue','keroseneIndexValue']
    },
    {
        title: ['当月','累计'],
        dateName:['month','sum']
    },
    {
        title: ['消费者信息指数','消费者满意指数','消费者预期指数'],
        dateName:['confidenceIndex','satisfactionIndex','expectedIndex'],
        yAxis :  { // 纵轴标尺固定
            type : 'value',
            scale : true,
            max : 200,
            min : 0,
            splitNumber : 2,
            boundaryGap : [ 0.2, 0.2 ]
        } ,
    },
    {
        title: ['当月','累计'],
        dateName:['month','sum']
    },
    {
        title: ['居民部门', '非金融部门', '政府部门', '中央政府', '地方政府', '实体经济部门', '金融部门资产方', '金融部门负债方'],
        dateName:['resident','nonFinancialEnterprises','government','centralGovernment','localGovernment','realEconomy','financialAsset','financialDebtors']
    }
]


